import 'jquery';
import '../utils/slick.js';

$(function () {
    var slider = $('.video-slider .video-slider__video-list');

    slider.slick({
        centerMode: true,
        centerPadding: '33.3%',
        slidesToShow: 1,
        arrows: true,
        prevArrow: '<div class="arrow-left"></div>',
        nextArrow: '<div class="arrow-right"></div>',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '30%',
                }
            },
            {
                breakpoint: 599,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '30px',
                }
            }
        ]
    });
});